import { render, staticRenderFns } from "./phoneInput.vue?vue&type=template&id=864b4d1e&scoped=true&"
import script from "./phoneInput.vue?vue&type=script&lang=js&"
export * from "./phoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864b4d1e",
  null
  
)

export default component.exports